import React from "react";

export const AppCard = ({ app, version, icon, download }) => {
    return (
        <div className='col-12 col-md-6 col-lg-4 mb-3 h-auto'>
            <div className='border rounded p-3 p-md-4 h-100 d-flex'>
                <div className='col-3 p-0 align-content-center'>
                    <img className='w-100' style={{ maxWidth: 160 }} src={require("../images/" + icon)} alt="Logo"/>
                </div>
                <div className='col-9 d-flex flex-column'>
                    <p className='font-weight-bold mb-1'> {app} </p>
                    <p className='text-secondary'> Versión: {version ?? ''} </p>
                    <div className='mt-auto bd-highlight col-12 col-sm-6 col-md-12 col-lg-12 col-xl-8 p-0' style={{ flex: "none" }}>
                        <button className='btn btn-outline-warning w-100 font-weight-bold' onClick={download}> <i className='fas fa-cloud-download-alt'/> Descargar </button>
                    </div>
                </div>
            </div>
        </div>
    );
};